"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderHistoryColumns = void 0;
const auth0_react_1 = require("@auth0/auth0-react");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonSize_1 = __importDefault(require("../../../common/js/enums/ButtonSize"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const dateformat_1 = require("../../../common/js/helper/dateformat");
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const LocalStorageKeys_1 = __importDefault(require("../../enums/LocalStorageKeys"));
const cart_1 = require("../../helper/cart");
const money_1 = require("../../helper/money");
const payment_1 = require("../../helper/payment");
const product_1 = require("../../helper/product");
const ShopwareCart_1 = __importDefault(require("../../stores/ShopwareCart"));
const ShopwareOrder_1 = __importDefault(require("../../stores/ShopwareOrder"));
const TableTile_1 = __importDefault(require("../TableTile"));
const UserProfileOrdersTableDetails_1 = __importDefault(require("./UserProfileOrdersTableDetails"));
class UserProfileOrders extends react_1.default.Component {
    contextReactionDisposer;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            orderId: mobx_1.computed,
        });
    }
    get orderId() {
        return this.props.match?.params?.orderId ?? null;
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('profile_subpage_title', { title: (0, translation_1.t)('user.profile.orders.title') });
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.customerId, () => {
            ShopwareOrder_1.default.loadOrdersForCompany();
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
    }
    render() {
        if (ShopwareOrder_1.default.isLoading) {
            return (react_1.default.createElement("section", { className: "znd-user-profile-page__table" },
                react_1.default.createElement(LoadingSpinner_1.default, { center: true })));
        }
        return (react_1.default.createElement("section", { className: "znd-user-profile-page__table" },
            react_1.default.createElement(TableTile_1.default, { columns: (0, exports.getOrderHistoryColumns)(), data: ShopwareOrder_1.default.ordersFromCompany, title: (0, translation_1.t)('user.profile.webshop_orders'), expandableComponent: UserProfileOrdersTableDetails_1.default, onExpandedRow: (row) => row.id === this.orderId, localStorageKey: LocalStorageKeys_1.default.ordersSort })));
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.ORDER_READ })((0, mobx_react_1.observer)(UserProfileOrders))));
const OrderDateColumn = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('user.profile.orders.table.order_date.column_name'),
    selector: (order) => new Date(order.orderDateTime).getTime(),
    sortable: true,
    minWidth: '6.875rem',
    cell: (order) => (0, dateformat_1.getDateFormat)(order.orderDateTime) ?? '',
});
const OrderNumberColumn = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('user.profile.orders.table.order_number.column_name'),
    selector: (order) => order.orderNumber,
    sortable: true,
});
const CustomerNameColumn = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('user.profile.orders.table.customer_name.column_name'),
    selector: (order) => `${order.orderCustomer?.firstName} ${order.orderCustomer?.lastName}`,
    sortable: false,
});
const OrderValueColumn = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('user.profile.orders.table.order_value.column_name'),
    selector: (row) => (!!row.currency?.isoCode ? (0, money_1.moneyFormat)(row.price.totalPrice, row.currency?.isoCode) : ''),
    sortable: false,
});
const PaymentMethodColumn = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('user.profile.orders.table.payment_method.column_name'),
    selector: (order) => {
        const paymentMethod = (0, payment_1.getCurrentOrderPaymentMethod)(order);
        return paymentMethod?.translated?.name ?? '';
    },
    sortable: false,
});
const ReorderColumn = () => ({
    allowOverflow: true,
    name: '',
    minWidth: '11.5rem',
    cell: (order) => react_1.default.createElement(ReorderCell, { order: order }),
});
const ReorderCell = ({ order }) => {
    {
        const [loading, setLoading] = (0, react_1.useState)(false);
        const [icon, setIcon] = (0, react_1.useState)(Zupicons_1.default.shoppingCart);
        if (!AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.CART_UPDATE)) {
            return react_1.default.createElement("div", { className: 'znd-user-profile-page__placeholder-button' });
        }
        const software = order.lineItems?.filter((item) => (0, product_1.isSoftware)(item.payload?.massiveAdditionalSeatsCount ?? null) ||
            null !== (item.payload?.zkpSoftwareOfferId ?? null)) ?? [];
        if (software.length > 0) {
            return react_1.default.createElement("div", { className: 'znd-user-profile-page__placeholder-button' });
        }
        const lineItemProducts = order.lineItems?.filter((item) => item.type === ecommerce_1.LineItemTypeEnum.Product &&
            !(0, product_1.isSoftware)(item.payload?.massiveAdditionalSeatsCount ?? null) &&
            null === (item.payload?.zkpSoftwareOfferId ?? null)) ?? [];
        return (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.CART_UPDATE] },
            react_1.default.createElement(Button_1.default, { className: 'znd-user-profile-page__reorder-button', variant: ButtonVariant_1.default.secondary, size: ButtonSize_1.default.small, text: (0, translation_1.t)('user.profile.orders.reorder.btn'), icon: icon, loading: loading, disabled: loading, onClick: (event) => {
                    event.preventDefault();
                    const lineItems = new Map();
                    lineItemProducts.forEach((lineItem, index) => {
                        lineItems.set(index, {
                            id: lineItem.productId,
                            referencedId: lineItem.productId,
                            quantity: lineItem.quantity,
                            type: ecommerce_1.LineItemTypeEnum.Product,
                            removable: true,
                            stackable: true,
                            payload: {
                                massiveAdditionalSeatsCount: lineItem.payload?.massiveAdditionalSeatsCount ?? null,
                            },
                        });
                    });
                    setLoading(true);
                    ShopwareCart_1.default.addLineItems(Array.from(lineItems.values()))
                        .then(() => {
                        setIcon(Zupicons_1.default.check);
                        setTimeout(() => {
                            setIcon(Zupicons_1.default.shoppingCart);
                        }, 1000);
                    })
                        .catch((response) => {
                        return (0, cart_1.handleAddToCartErrorResponse)(response);
                    })
                        .finally(() => setLoading(false));
                } })));
    }
};
const defaultColumnsCallback = () => [
    OrderDateColumn(),
    OrderNumberColumn(),
    CustomerNameColumn(),
    OrderValueColumn(),
    PaymentMethodColumn(),
    ReorderColumn(),
];
const getOrderHistoryColumns = () => defaultColumnsCallback();
exports.getOrderHistoryColumns = getOrderHistoryColumns;
